export enum MapZoom {
  INITIAL = 13,
  DEFAULT_MAX = 22,
  HIGH_RES_MAX = 25,
  TILE_NATIVE_ZOOM_MAX = 20,
}
